import React from 'react';
import { RoomType } from '../../../../services/ConfigurationService/types/roomType';
import { Button, TextField, Dialog, DialogTitle, DialogContent, DialogActions, Stack, Typography, Switch } from '@mui/material';
import { useUpsertRoomMutation } from '../../../../services/ConfigurationService';

interface EditRoomDialogProps {
  open: boolean;
  onClose: () => void;
  centerId: string;
  room: RoomType;
  onSave: () => void;
}

const EditRoomDialog: React.FC<EditRoomDialogProps> = ({ open, onClose, centerId, room, onSave }) => {
  const [description, setDescription] = React.useState(room.description || '');
  const [isInactive, setIsInactive] = React.useState(room.isInactive || false);
  const [upsertRoom, { isLoading }] = useUpsertRoomMutation();
  const [error, setError] = React.useState<string | null>(null);

  React.useEffect(() => {
    setDescription(room.description || '');
    setIsInactive(room.isInactive || false);
    setError(null);
  }, [room, open]);

  const handleSave = async () => {
    try {
      await upsertRoom({ ...room, centerId, description, isInactive }).unwrap();
      onSave();
    } catch (e: any) {
      setError(e?.data?.message || 'Failed to save room.');
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Edit Room</DialogTitle>
      <DialogContent>
        <TextField
          margin="dense"
          label="Code"
          fullWidth
          value={room.code}
          disabled
        />
        <TextField
          margin="dense"
          label="Description"
          fullWidth
          value={description}
          onChange={e => setDescription(e.target.value)}
        />
        <Stack direction='row' alignItems='center' gap={1} sx={{ marginTop: 2 }}>
          <Typography>Inactive Room</Typography>
          <Switch checked={isInactive} onChange={e => setIsInactive(e.target.checked)} />
        </Stack>
        {error && <div style={{ color: 'red', marginTop: 8 }}>{error}</div>}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isLoading}>Cancel</Button>
        <Button onClick={handleSave} color="primary" variant="contained" disabled={isLoading}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditRoomDialog;


